export class QuestionModule {

    aqQuestionID: number = 0;
    title: string = '';
    question: string = '';
    answer1: string = '';
    answer2: string = '';
    answer3: string = '';
    answer4: string = '';
    correctAnswerNo: number = 0;
    correctAnswerName: string = '';
    addDate: Date = new Date();
    isActive: boolean;


}
